import React from "react";
import "./contentful-long-text.css";

const ContentfulLongText = ({
  longTextContent,
  classNameProp = "",
  isJustify = true,
  hasLimitChar = false,
  styleVal,
  isThumbnail = false, // New parameter
}) => {
  if (isThumbnail) {
    let formattedContent = longTextContent
        .replace(/__([^_]+?)__/g, "<strong>$1</strong>") // Bold
        .replace(/\*([^*]+?)\*/g, "<em>$1</em>") // Italic
        .replace(/\*\*\_\_([^*]+?)\_\_\*\*/g, "<strong><em>$1</em></strong>") // Bold + Italic
        .replace(/^>\s*(.*)$/gm, "<blockquote>$1</blockquote>") // Blockquote
        .replace(/\[([^[\]]+)\]\((https?:\/\/[^)\s]+)\s*("([^"]+)")?\)/g, '<a href="$2" title="$4">$1</a>') // Links
        .replace(/\^/g, "-") // Replace ^ with -
        .replace(/!\[([^\]]*)\]\((\/\/[^\s\)]+)\)/g, '<img src="https:$2" alt="$1" />'); // Images

    const stripHtml = (html) => {
        return html
            .replace(/<\/?[^>]+(>|$)/g, "") // Remove HTML tags
            .replace(/\d+\.\s+/g, "") // Remove numbering like "1. ", "2. ", etc., at the start of a line
            .replace(/-\s+/g, "") // Remove dashes if they are at the start of a line
            .replace(/^(#+)\s*/gm, "") // Remove Markdown heading markers like #, ##, ###
            .replace(/(\n|\r)/g, " ") // Replace line breaks with spaces
            .trim();
    };    
    

    // Strip HTML tags and process plain text
    const plainTextContent = stripHtml(formattedContent);

    let contentVal;

    if (hasLimitChar && plainTextContent.length > 300) {
        // Truncate the plain text
        const truncatedText = plainTextContent.substring(0, 300) + "...";

        // Rebuild the truncated HTML content based on visible text
        let currentVisibleLength = 0;
        contentVal = "";
        formattedContent.replace(/(<[^>]+>|[^<]+?)/g, (chunk) => {
            if (currentVisibleLength >= truncatedText.length) return;
            if (!chunk.startsWith("<")) {
                // Add visible text
                const remainingLength = truncatedText.length - currentVisibleLength;
                contentVal += chunk.substring(0, remainingLength);
                currentVisibleLength += chunk.length;
            } else {
                // Add HTML tags
                contentVal += chunk;
            }
        });

        contentVal += "...";
    } else {
        // No truncation, return full content
        contentVal = formattedContent;
    }

    return (
        <div
            className={`mb-10 whitespace--prewrap ${isJustify ? "text-left" : "text-center"} richtext-content align-self-center ${classNameProp}`}
            style={styleVal ? styleVal : {}}
            dangerouslySetInnerHTML={{ __html: stripHtml(contentVal) }} // Render processed plain text
        />
    );
  } else {
    let formattedContent = longTextContent
    .replace(/__([^_]+?)__/g, '<strong>$1</strong>') 
    .replace(/\*([^*]+?)\*/g, '<em>$1</em>') 
    .replace(/\*\*\_\_([^*]+?)\_\_\*\*/g, '<strong><em>$1</em></strong>')
    .replace(/^>\s*(.*)$/gm, '<blockquote>$1</blockquote>')
    .replace(/^- (.*)$/gm, '<li>$1</li>')
    .replace(/\[([^[\]]+)\]\((https?:\/\/[^)\s]+)\s*("([^"]+)")?\)\[blank\]/g, '<a href="$2" title="$4" target="_blank" rel="nofollow noopener noreferrer">$1</a>')
    .replace(/\[([^[\]]+)\]\((https?:\/\/[^)\s]+)\s*("([^"]+)")?\)\[NoFollow\]/g, '<a href="$2" title="$4" target="_blank" rel="nofollow noopener noreferrer">$1</a>')
    .replace(/\[([^[\]]+)\]\((https?:\/\/[^)\s]+)\s*("([^"]+)")?\)/g, '<a href="$2" title="$4">$1</a>')
    .replace(/\^/g, "-")
    // Add this line to replace Markdown image syntax with HTML <img> tag
    .replace(/!\[([^\]]*)\]\((\/\/[^\s\)]+)\)/g, '<img src="https:$2" alt="$1" />');
    const contentLines = formattedContent.split('\n');
    let isInList = false;
    for (let i = 0; i < contentLines.length; i++) {
        if (contentLines[i].startsWith('<li>')) {
            if (!isInList) {
                contentLines[i] = '<ul>' + contentLines[i];
                isInList = true;
            }
            contentLines[i] = contentLines[i].replace('<li>', '<li>').replace('</li>', '</li>');
        } else {
            if (isInList) {
                contentLines[i - 1] += '</ul>';
                isInList = false;
            }
        }
    }
    if (isInList) {
        contentLines[contentLines.length - 1] += '</ul>';
    }
    formattedContent = contentLines.join('\n');
    formattedContent = formattedContent.replace(/^#+\s*(.*)$/gm, (match, p1) => {
        const hashCount = match.match(/^#+/)[0].length;
        return `<h${hashCount}>${p1}</h${hashCount}>`;
    });
    formattedContent = formattedContent.trim();
    
    let neweFormattedContent = formattedContent.replace(/<(img|iframe)[^>]*>/g, '');
    neweFormattedContent = neweFormattedContent.replace(/<\/?(h[2-6])[^>]*>/g, '');
    neweFormattedContent = neweFormattedContent.replace(/<\/?ul[^>]*>/g, '');
    neweFormattedContent = neweFormattedContent.replace(/<\/?li[^>]*>/g, '');
    neweFormattedContent = neweFormattedContent.replace(/(\n|\r)/g, ' ').trim();
    let contentVal;
    if (hasLimitChar && formattedContent.length > 300) {
        contentVal = neweFormattedContent.substring(0, 300) + '...';
    } else {
        contentVal = formattedContent;
    }
    return (
        <div className={`mb-10 whitespace--prewrap ${isJustify ? 'text-left':'text-center'} richtext-content align-self-center ${classNameProp}`} style={styleVal ? styleVal : {}} dangerouslySetInnerHTML={{ __html: contentVal }} />
    )
  }
};

export default ContentfulLongText;